import React from 'react';
import LabelValue from '../labelValue/labelValue';
import './overview.scss';
import trans from '../../translations.json';
import moment from 'moment';
import ReducedData from '../../reducedData.json';

let reprodNumbers = [...ReducedData.effectiveReproduction.reverse()];

const latestReprod = reprodNumbers[0].Re;
const prevReprod = reprodNumbers[1].Re;
const reprodDiff = (latestReprod - prevReprod).toFixed(2);

const OverviewTable = (props) => (
  <>
    {' '}
    {props.lastUpdated ? (
      <div className="ontario-row">
        {!props.withStatus ? (
          <div className="ontario-column ontario-medium-12 ontario-margin-top-24-!">
            <div className="ontario-section__covid-stats-title">
              <h2>{trans.overview.title[props.lang]}</h2>
              <p>{props.lastUpdated}</p>
              {props.totalSinceInOverview && (
                <p>
                  {trans.overview.since[props.lang]}{' '}
                  {moment(props.totalSinceInOverview).format(
                    props.lang === 'en'
                      ? 'MMMM D, YYYY'
                      : 'DD MMMM YYYY',
                  )}
                  .
                </p>
              )}
              {props.type && (
                <p>
                  {trans.overview.updatedInfo[props.type][props.lang]}
                </p>
              )}
            </div>
          </div>
        ) : (
            <>
              <div
                className={
                  props.columnLeftClasses ||
                  'ontario-column ontario-small-12 ontario-medium-6  ontario-margin-top-24-!'
                }
              >
                <div className="ontario-section__covid-stats-title">
                  <h2>{trans.overview.title[props.lang]}</h2>
                  <p>{props.lastUpdated}</p>
                  {props.totalSinceInOverview && (
                    <p>
                      {trans.overview.since[props.lang]}{' '}
                      {moment(props.totalSinceInOverview).format(
                        props.lang === 'en'
                          ? 'MMMM D, YYYY'
                          : 'DD MMMM YYYY',
                      )}
                    .
                    </p>
                  )}
                  {props.type ? (
                    <p>
                      {
                        trans.overview.updatedInfo[props.type][
                        props.lang
                        ]
                      }
                    </p>
                  ) : null}
                </div>
              </div>
              <div
                className={
                  props.columnRightClasses ||
                  'ontario-column ontario-small-12 ontario-medium-6  ontario-margin-top-24-!'
                }
              >
                <div className="ontario-section__covid-stats-title">
                  <h2>{props.status.title}</h2>
                  <p>{props.status.text}</p>
                </div>
              </div>
            </>
          )}
      </div>
    ) : null}
    <div className="ontario-row">
      {props.stats.cumm && (
        <div
          className={
            props.columnLeftClasses ||
            'ontario-column ontario-small-12 ontario-medium-6  ontario-margin-top-24-!'
          }
        >
          <>
            <div id="cviz-overview-header">
              <div>
                {props.showTitle !== false && (
                  <div className="ontario-label">
                    {trans.overview.allCases[props.lang]}{' '}
                  </div>
                )}
                {props.totalSince && (
                  <p className={props.additionalTotalsHeadingDescription && `ontario-margin-bottom-0-!`}>
                    {trans.overview.since[props.lang]}{' '}
                    {moment(props.totalSince).format(
                      props.lang === 'en'
                        ? 'MMMM D, YYYY'
                        : 'DD MMMM YYYY',
                    )}
                    .
                  </p>
                )}
                {props.additionalTotalsHeadingDescription &&
                  <p>{props.additionalTotalsHeadingDescription}</p>
                }
              </div>
              <div>
                <div className="ontario-label">
                  {!props.newCasesHeading
                    ? trans.overview.Change[props.lang]
                    : 'New Cases'
                  }
                </div>
                {props.newCasesHeading
                  ? "Change from last report"
                  : <p>{trans.overview.fromPrevDay[props.lang]}</p>
                }
              </div>
            </div>
            <ul className="ontario-no-bullet cviz-overview-list">
              {props.stats.cumm &&
                props.stats.cumm.map((item, idx) => (
                  <li key={idx}>
                    <LabelValue
                      smallLabel={props.smallLabel}
                      label={item.label}
                      value={item.value}
                      lang={props.lang}
                      difference={item.difference}
                    />
                  </li>
                ))}
            </ul>
          </>
        </div>
      )}
      <div
        className={
          props.columnRightClasses ||
          'ontario-column ontario-small-12 ontario-medium-6 ontario-margin-top-24-!'
        }
      >
        {props.stats.curr && (
          <>
            {props.showTitle !== false && (
              <div id="cviz-overview-header">
                <div>
                  <div className="ontario-label">
                    {props.labels[0]}
                  </div>
                  <p className={props.additionalStatusHeadingDescription && `ontario-margin-bottom-0-!`}>{props.descs[0]}</p>
                  {props.additionalStatusHeadingDescription &&
                    <p>{props.additionalStatusHeadingDescription}</p>
                  }
                </div>
                {/* <h3>{trans.overview.inHospital[props.lang]}</h3>
                  <p>{trans.overview.currently[props.lang]}</p> */}
                <div>
                  <div className="ontario-label">
                    {!props.alternativeChangeHeading
                      ? trans.overview.Change[props.lang]
                      : props.alternativeChangeHeading
                    }
                  </div>
                  {props.newCasesHeading
                    ? "Change from last report"
                    : <p>{trans.overview.fromPrevDay[props.lang]}</p>
                  }

                </div>
              </div>
            )}
            <ul className="ontario-no-bullet cviz-overview-list">
              {props.stats.curr &&
                !props.isLTC &&
                props.stats.curr.map((item, idx) => (
                  <li key={idx}>
                    <LabelValue
                      smallLabel={props.smallLabel}
                      label={item.label}
                      value={item.value}
                      lang={props.lang}
                      difference={item.difference}
                    />
                  </li>
                ))}
              {props.stats.curr &&
                props.isLTC &&
                props.stats.curr.map((item, z) => {
                  return z === 0 ? (
                    <li key={z}>
                      <LabelValue
                        isLink={true}
                        smallLabel={props.smallLabel}
                        label={item.label}
                        value={item.value}
                        lang={props.lang}
                        difference={item.difference}
                      />
                    </li>
                  ) : (
                      <li key={z}>
                        <LabelValue
                          smallLabel={props.smallLabel}
                          label={item.label}
                          value={item.value}
                          lang={props.lang}
                          difference={item.difference}
                        />
                      </li>
                    );
                })}
            </ul>
          </>
        )}
        {props.stats.thirdTable && (
          <>
            {props.showTitle !== false && (
              <div id="cviz-overview-header">
                <div>
                  <div className="ontario-label">
                    {props.labels[1]}
                  </div>
                  <p>{props.descs[1]}</p>
                </div>
                {/* <h3>{trans.overview.inHospital[props.lang]}</h3>
                <p>{trans.overview.currently[props.lang]}</p> */}
                <div>
                  <div className="ontario-label">
                    {trans.overview.Change[props.lang]}
                  </div>
                  <p>{trans.overview.fromPrevDay[props.lang]}</p>
                </div>
              </div>
            )}
            <ul className="ontario-no-bullet cviz-overview-list">
              {props.stats.curr &&
                !props.isLTC &&
                props.stats.thirdTable.map((item, idx) => (
                  <li key={idx}>
                    <LabelValue
                      smallLabel={props.smallLabel}
                      label={item.label}
                      value={item.value}
                      lang={props.lang}
                      difference={item.difference}
                    />
                  </li>
                ))}
            </ul>
          </>
        )}
        {props.withReproduction && !props.stats.curr && (
          <>
            <div id="cviz-overview-header">
              <div>
                <div
                  className="ontario-label"
                  dangerouslySetInnerHTML={{
                    __html:
                      trans.overview.reproduction.title[props.lang],
                  }}
                ></div>
              </div>

              <div>
                <div className="ontario-label">
                  {trans.overview.Change[props.lang]}
                </div>
                <p>{trans.overview.fromPrevWeek[props.lang]}</p>
              </div>
            </div>
            <ul className="ontario-no-bullet cviz-overview-list">
              <li>
                <LabelValue
                  smallLabel={props.smallLabel}
                  label={
                    trans.overview.reproduction.label[props.lang]
                  }
                  value={latestReprod}
                  lang={props.lang}
                  difference={reprodDiff}
                />
              </li>
              <li>
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      trans.overview.reproduction.descA[props.lang] +
                      trans.overview.reproduction.descB[props.lang] +
                      '.',
                  }}
                ></p>
              </li>
            </ul>
          </>
        )}
      </div>
    </div>
    {props.withReproduction && props.stats.curr && (
      <div className="ontario-row ontario-margin-bottom-32-!">
        <div className="ontario-column ontario-small-12 ontario-medium-6">
          <div id="cviz-overview-header">
            <div>
              <div
                className="ontario-label"
                dangerouslySetInnerHTML={{
                  __html:
                    trans.overview.reproduction.title[props.lang],
                }}
              ></div>
            </div>
            <div>
              <p>{trans.overview.fromPrevWeek[props.lang]}</p>
            </div>
          </div>
          <ul className="ontario-no-bullet cviz-overview-list">
            <li>
              <LabelValue
                smallLabel={props.smallLabel}
                label={trans.overview.reproduction.label[props.lang]}
                value={latestReprod}
                lang={props.lang}
                difference={reprodDiff}
              />
            </li>
            {/* <li>
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    trans.overview.reproduction.descA[props.lang] +
                    trans.overview.reproduction.descB[props.lang]
                }}
              ></p>
            </li> */}
          </ul>
        </div>
      </div>
    )}
  </>
);

export default OverviewTable;
